module.exports = __webpack_public_path__ + "static/media/bg_login.294fd13b.svg";